// extracted by mini-css-extract-plugin
export default {"group":"group-v8MiwVT5","headerText":"headerText-nX_gINZR","container":"container-CMLToPWd"};